import React from 'react'
import { components } from 'react-select'

// COUPLING: `optionsLoadFailureMessage` in
// `apps/panelpunches/api-test/src/browser/support/page-objects/admin/OrderFromConversationPage.ts`
// re-declares this string (browser files cannot import `@ztechapps`).
export const loadOptionsFailedMessage = 'Could not load options — type to retry'

export const LoadFailedNoOptionsMessage = (props: any) => (
  <components.NoOptionsMessage {...props} className="text-danger">
    {loadOptionsFailedMessage}
  </components.NoOptionsMessage>
)
